import React from 'react';

import {Icon } from 'antd';

export default class FileBase64 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            files: [],
        };
    }

    handleChange(e) {

        // get the files
        let files = e.target.files;

        // Process each file
        var allFiles = [];
        for (var i = 0; i < files.length; i++) {

            let file = files[i];
            var ciccio = file.type.toString();
            var extension = ciccio.substr(6);
            var weight = Math.round(file.size / 1000);
            var formatoGiusto = extension === "jpg" || extension === "png" || extension === "jpeg" || extension === "svg+xml" ? true : false
            var pesoGiusto = weight < 150 ? true : false
            var warning1 = document.getElementById("wrongSize");
            var h4sotto = document.getElementById("h4Desc");
            var warning2 = document.getElementById("wrongExtension");

            if (formatoGiusto && pesoGiusto) {

                // Make new FileReader
                let reader = new FileReader();

                // Convert the file to base64 text
                reader.readAsDataURL(file);

                // on reader load somthing...
                reader.onload = () => {

                    // Make a fileInfo Object
                    let fileInfo = {
                        name: file.name,
                        type: file.type,
                        size: Math.round(file.size / 1000) + ' kB',
                        base64: reader.result.split(',')[1],
                        file: file,
                    };

                    // Push it to the state
                    allFiles.push(fileInfo);

                    // If all files have been proceed
                    if (allFiles.length === files.length) {
                        // Apply Callback function
                        if (this.props.multiple) this.props.onDone(allFiles);
                        else this.props.onDone(allFiles[0]);
                    }

                } // reader.onload
                           
                if (warning1.style.display = "block") {
                    warning1.style.display = "none";
                    if (h4sotto) { h4sotto.style.marginTop = "42px"; }
                }
                if (warning2.style.display = "block") {
                    warning2.style.display = "none";
                    if (h4sotto) { h4sotto.style.marginTop = "42px"; }
                }

            } else if (formatoGiusto) {  
                if (warning2.style.display = "block") {
                    warning2.style.display = "none";
                }
                allFiles = []
                this.props.onDone(allFiles)
                warning1.style.display = "block";                
                if (h4sotto) { h4sotto.style.marginTop = "25px"; }
                document.getElementById("imgLogoUpload").value = "";
            } else {   
                if (warning1.style.display = "block") {
                    warning1.style.display = "none";
                }
                allFiles = []
                this.props.onDone(allFiles)
                warning2.style.display = "block";                
                if (h4sotto) { h4sotto.style.marginTop = "25px"; }
                document.getElementById("imgLogoUpload").value = "";
            }
                    

        } // for

    }

    render() {
        return (
            <div style={{
                width: 150,                
                display: 'inline-block'
            }}>
            <input autoComplete="new-password"
                    className="inputBase64"
                    type="file"
                    id="imgLogoUpload"
                    name="imgLogoUpload"
                    value={this.state.file}
                    onChange={this.handleChange.bind(this)}
                    multiple={this.props.multiple}
                    style={{ display: 'none' }}
                />
                <label style={{ width: '150px' }} htmlFor="imgLogoUpload"><Icon type="upload" /> Choose a file</label>
            </div>
        );
    }
}

FileBase64.defaultProps = {
    multiple: false,
};


// WEBPACK FOOTER //
// ./src/util/Input64.js